'use client';

import ButtonBigCall from '@components/button-big-call/ButtonBigCall';
import { useRouter } from 'next/navigation';

const ProgressButton = ({ text, className, route }) => {
  const router = useRouter();

  return <ButtonBigCall text={text} className={className} handleFuction={() => router.push(route)} />;
};

export default ProgressButton;
